import { useEffect, useMemo, useRef } from 'react';

import { useAppSelector } from 'store/store-hooks';
import { selectFiles } from 'components/app/_mediator/app-files.slice';
import { sortProjectEntities } from 'components/app/projects/_mediator/projects.helper';
import { getFileSortCb, PROJECTS_FILES_HEADERS } from 'components/app/projects/_mediator/projects.params';
import { useSelectorFiles } from 'components/app/selector/_mediator/use-selector-files';

import { SelectorFilesMenuTrigger } from './elements/selector-files-menu';
import { SelectorFilesElement } from './elements/selector-files-element';
import { SelectorFilesSortSelect } from './elements/selector-files-sort-select';
import styles from './_selector-files.module.scss';

export const SelectorFiles = () => {
  const { videos, images } = useAppSelector(selectFiles);
  const tracksRestored = useAppSelector((state) => state.memory.tracksRestored);
  const selectedFile = useAppSelector((state) => state.projects.selectedFile);
  const filesTableSort = useAppSelector((state) => state.projects.filesTableSort);
  const container = useRef<HTMLDivElement>(null);
  const isScrolled = useRef(false);

  const sortedFiles = useMemo(() => {
    return sortProjectEntities(
      [...videos, ...images],
      filesTableSort.order,
      getFileSortCb(PROJECTS_FILES_HEADERS[filesTableSort.column])
    );
  }, [filesTableSort, images, videos]);

  useEffect(() => {
    if (!tracksRestored || !sortedFiles.length || isScrolled.current) return;
    const i = sortedFiles.findIndex((el) => el.id === selectedFile);
    const el = container.current!.children[i + 1] as HTMLDivElement;
    container.current!.scrollTop = el.offsetTop;
    isScrolled.current = true;
  }, [sortedFiles, tracksRestored]);

  useSelectorFiles();

  return (
    <div ref={container} className={styles.SelectorFiles}>
      <SelectorFilesSortSelect />
      {sortedFiles.map((el) => (
        <SelectorFilesMenuTrigger key={el.id} fileId={el.id}>
          <SelectorFilesElement file={el} />
        </SelectorFilesMenuTrigger>
      ))}
    </div>
  );
};
